export const COMMON = {
  COMPONENT_PREFIX: 'sc',
  UNSELECT_DROPDOWN_TITLE: 'Select',
  DEFAULT_PLACEHOLDER: 'Input value',
  DEFAULT_ITEM_TEXT: 'text',
  DEFAULT_ITEM_VALUE: 'value',
  NOT_SELECTED: -1
};

export default {
  COMMON
};

export const EVENT_POPUP = {
  DATE_TIME_PICKER: 'date-time-picker',
  INSIGHT_CHART: 'insight-chart-popup'
};
